module.exports = __webpack_public_path__ + "img/logo.b573c52f.png";